<template lang="pug">
.pagination
  ul.pagination-list(v-if ='pageCount > 1')
    li(
      v-bind:class="{'is-disable': activePage == 1}"
    )
      button.pagination-list__prev(
        v-on:click="decrementPage"
      )

    li(
      v-for='index in pageCount' :key='index'
      v-bind:class="{'is-active': activePage==index}"
      )
      button(
        :data-page-number="index"
        class="pagination-list__button"
        v-on:click="changePage"
      ) {{index}}

    li(
      v-bind:class="{'is-disable': activePage == pageCount}"
    )
      button.pagination-list__next(
        v-on:click="incrementPage"
        )
</template>

<script>

  import store from '~/js/store'
  const pagination = {
    data() {
      return {
      }
    },
    props: {
      pageCount: {
        type: Number
      },
      activePage: {
        type: Number
      }
    },
    methods: {
      changePage(event) {
        store.dispatch('setProductsItemsPage', event.target.dataset.pageNumber)
      },
      incrementPage() {
        let incremented
        incremented = this.activePage + 1
        store.dispatch('setProductsItemsPage', incremented)
      },
      decrementPage() {
        let decremented
        decremented = this.activePage -1

        store.dispatch('setProductsItemsPage', decremented)
      }
    }
  }

  export default pagination
</script>
